import { Helmet } from "react-helmet-async";

const SITE = "https://zejzen.com";

/* Per-page SEO: unique title, meta description, canonical, optional JSON-LD + og:image */
export function SEO({ title, description, path = "/", jsonLd, noindex = false, image }) {
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {noindex && <meta name="robots" content="noindex, follow" />}
      <link rel="canonical" href={`${SITE}${path}`} />
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={`${SITE}${path}`} />
      {image && <meta property="og:image" content={image} />}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
